import { Button, Modal, Table, Tag, Space } from 'antd'
import service from '../../../@services'
import useEditSupplier from '../hooks/useEditSupplier'
import AuthComponent from '../../../components/AuthComponent'

const tableColumes = (editSupplier, updateSupplier) => {
  return [
    {
      title: 'id',
      dataIndex: 'id',
      key: 'id',
      width: 50
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      key: 'supplierName'
    },
    {
      title: '公司名称',
      dataIndex: 'companyName',
      key: 'companyName'
    },
    {
      title: '联系人',
      dataIndex: 'contactName',
      key: 'contactName'
    },
    {
      title: '联系电话',
      dataIndex: 'contactPhone',
      key: 'contactPhone'
    },
    {
      title: '状态',
      dataIndex: 'validity',
      key: 'validity',
      width: 80,
      render: validity => {
        switch (validity) {
          case -1:
            return (
              <Tag color='grey' size>
                已删除
              </Tag>
            )
          case 0:
            return <Tag color='#f50'>已禁用</Tag>
          case 1:
            return <Tag color='#87d068'>已启用</Tag>
          default:
            break
        }
      }
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      width: 160
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      ellipsis: true
    },
    {
      title: '操作',
      dataIndex: 'id',
      key: 'operation',
      render: (id, rowData) => {
        return (
          <Space>
            <AuthComponent authKey='/supplier/update'>
              <Button onClick={() => editSupplier(id)} size='small' type='link'>
                修改
              </Button>
            </AuthComponent>
            <AuthComponent authKey='/supplier/update-status'>
              {rowData.validity === 1 && (
                <Button
                  onClick={() => updateSupplier(rowData)}
                  size='small'
                  type='link'>
                  禁用
                </Button>
              )}
              {rowData.validity === 0 && (
                <Button
                  onClick={() => updateSupplier(rowData)}
                  size='small'
                  type='link'>
                  启用
                </Button>
              )}
            </AuthComponent>
          </Space>
        )
      }
    }
  ]
}

export default function SuppliersTable({
  suppliers,
  onEditSupplierFinish,
  onEditSupplierFail,
  pager,
  loading
}) {
  const { editSupplier } = useEditSupplier()
  const editSupplierFinish = id => {
    return editSupplier(id)
      .then(res => {
        if (typeof onEditSupplierFinish === 'function') {
          onEditSupplierFinish(res)
        }
      })
      .catch(e => {
        if (typeof onEditSupplierFail === 'function') {
          onEditSupplierFail(e)
        }
      })
  }
  const updateSupplierStatus = data => {
    let { id, validity, supplierName } = data
    let confirmText = ''
    if (validity === 1) {
      validity = 0
      confirmText = '禁用'
    } else if (validity === 0) {
      validity = 1
      confirmText = '启用'
    }
    const modal = Modal.confirm({
      centered: true,
      title: '提示',
      content: `确认${confirmText} ${supplierName} 吗？`,
      onOk: () => {
        return service.supplier
          .updateStatus({
            id,
            validity
          })
          .then(() => {
            onEditSupplierFinish && onEditSupplierFinish()
            modal.destroy()
          })
      }
    })
  }
  return (
    <Table
      rowKey='id'
      columns={tableColumes(editSupplierFinish, updateSupplierStatus)}
      dataSource={suppliers}
      loading={loading}
      pagination={{
        position: ['bottomRight'],
        showQuickJumper: true,
        showTotal: total => `当前条件共检索到  ${total} 条相关信息`,
        ...pager
      }}
    />
  )
}
